import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EfVideo from '@elem/ui/ef-video';
import EcoImg from 'eco-design/base/eco-img';
import EcoSection from 'eco-design/base/eco-section';
import { FC, useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useMediaDevice } from '../Brands/hooks';
import MinTitle from '../MinTitle';
import AIDriven from './AIDriven';
import { imgItems, langConfig, videos } from './config';
import EcoSpace from 'eco-design/base/eco-space';
import Epexspot from './icons/Epexspot';
import Octopus from './icons/Octopus';
import Nord from './icons/Nord';
import Rabot from './icons/Rabot';
import Smart from './Smart';
import styled from './index.module.scss';
import SmartMeter from '@elem/compPage/stream-ultra-home-solar-system/pages/product/components/SmartMeter';
interface EcoAiProps {
    pageType: string;
}

const euPages = ['normal', 'ultra', 'ac'];

const IconRePlay = (props: any) => {
    return (
        <div {...props}>
            <span>Replay</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path
                    d="M10.1588 10.6681C9.27999 11.5469 8.06593 12.0904 6.7249 12.0904C4.04288 12.0904 1.86865 9.91621 1.86865 7.23418C1.86865 4.55215 4.04288 2.37793 6.7249 2.37793C8.06593 2.37793 9.27999 2.92148 10.1588 3.8003C10.6061 4.24761 11.5812 5.34564 11.5812 5.34564"
                    stroke="#999999"
                    strokeWidth="0.925"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M11.5814 2.91748V5.34561H9.15332" stroke="#999999" strokeWidth="0.925" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
};
const EcoAi: FC<EcoAiProps> = ({ pageType = 'normal' }) => {
    const { locale } = getLocal();
    const { isH5, isPad } = useMediaDevice();
    const [startPlay, setStartPlay] = useState(false);

    const { t } = useLang('theProduct.EcoAi');
    const pageTypeObj: any = {
        normal: {
            energy: [
                {
                    type: 'video',
                    desc: t('energy_item1_tilte'),
                    title: t('card1.title'),
                    ...videos[locale],
                },
                {
                    type: 'img',
                    desc: t('energy_item2_tilte'),
                    title: t('card2.title'),
                    pc: imgItems[locale][0][0],
                    h5: imgItems[locale][0][1],
                },
                {
                    type: 'img',
                    desc: t('energy_item3_tilte'),
                    title: t('card3.title'),
                    pc: imgItems[locale][1][0],
                    h5: imgItems[locale][1][1],
                },
            ],
        },
        na: {
            energy: [
                {
                    type: 'img',
                    desc: t('energy_item1_tilte'),
                    title: t('card1.title'),
                    pc: imgItems[locale]?.[4]?.[0],
                    h5: imgItems[locale]?.[4]?.[1],
                },
                {
                    type: 'img',
                    desc: t('energy_item2_tilte'),
                    title: t('card2.title'),
                    pc: imgItems[locale][0][0],
                    h5: imgItems[locale][0][1],
                },
                {
                    type: 'img',
                    desc: t('energy_item3_tilte'),
                    title: t('card3.title'),
                    pc: imgItems[locale][1][0],
                    h5: imgItems[locale][1][1],
                },
            ],
        },
    };
    const objectA = pageTypeObj[pageType] || pageTypeObj['normal'];
    const arr = objectA.energy || [];
    const currentLangConfig = langConfig[locale] || {};
    // 进入模块视频播放
    useEffect(() => {
        if (pageType === 'na') {
            return;
        }

        const callback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setStartPlay(true);
                }
            });
        };
        const play = new IntersectionObserver(callback, {
            threshold: 0.1,
        });
        play.observe(document.querySelector('.energy-ai') as HTMLDivElement);

        return () => {
            play.disconnect();
        };
    }, []);
    const icons = [Epexspot, Octopus, Nord, Rabot];
    let boots_title = t('boots_title');
    if (pageType === 'ultra') {
        boots_title = t('ultra_boots_title');
    } else if (pageType === 'ac') {
        boots_title = t('ac_boots_title');
    }
    let ai_r_title = t('ai_r_title');
    if (pageType === 'ultra') {
        ai_r_title = t('ultra_ai_r_title');
    } else if (pageType === 'ac') {
        ai_r_title = t('ac_ai_r_title');
    }
    let energy_ai_title = t('energy_ai_title');
    if (pageType === 'ultra') {
        energy_ai_title = t('ultra_energy_ai_title');
    } else if (pageType === 'ac') {
        energy_ai_title = t('ac_energy_ai_title');
    }
    const localobj: any = {
        de: {
            tou_video_pc: 'https://websiteoss.ecoflow.com/upload/video/1747132808685/%E5%B8%82%E7%94%B5PC%E7%AB%AF-DE_H.264.mp4',
            tou_video_h5: 'https://websiteoss.ecoflow.com/upload/video/1747132808514/%E5%B8%82%E7%94%B5%E7%A7%BB%E5%8A%A8%E7%AB%AF-DE_H.264.mp4',
        },
        eu: {
            tou_video_pc: 'https://websiteoss.ecoflow.com/upload/video/1745484565101/4e98d2d5ecab2035cd85334b9648a3aff6265a40.mp4',
            tou_video_h5: 'https://websiteoss.ecoflow.com/upload/video/1745486625982/930c982844c51d3d646aac4520a54f530cc6f0e6.mp4',
        },
    };
    const currentLangObj = localobj[locale] || localobj['eu'];
    return (
        <section id="EcoAi" className={`${styled.EcoAi} GtmModuleData-section`} data-section-id="EcoAi" data-section-title={t('tou_title')}>
            <AIDriven pageType={pageType}></AIDriven>
            <div className="tou-ai">
                <div className="tou-ai-container">
                    {euPages.includes(pageType) && (
                        <div className="tou-ai-new">
                            <MinTitle title={t('save_more')} align="center" />
                            <p className="tou-ai-desc">{boots_title}</p>
                            <div className="percent-box">
                                <div className="percent-item">
                                    <p className="percent-item-title">{t('boots_item1_tilte')}</p>
                                    <p className="percent-item-desc">{t('boots_item1_desc')}</p>
                                </div>
                                <div className="percent-item">
                                    <p className="percent-item-title yellow">{t('boots_item2_tilte')}</p>
                                    <p className="percent-item-desc">{t('boots_item2_desc')}</p>
                                </div>
                                <div className="percent-item">
                                    <p className="percent-item-title">{t('boots_item3_tilte')}</p>
                                    <p className="percent-item-desc">{t('boots_item3_desc')}</p>
                                </div>
                            </div>
                            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
                        </div>
                    )}

                    <div className="tou-box">
                        <EcoSection className="tou-box-title product-section" subTitle={t('tou_subtitle')} title={t('tou_title')} subTitleColor="#83868D" />
                        {euPages.includes(pageType) && (
                            <div className="status-box">
                                <div className="status-item">
                                    <div className="status-item-title">{t('tou_item1_title')}</div>
                                    <div className="status-item-desc">{t('tou_item1_desc')}</div>
                                </div>
                                <div className="status-line"></div>
                                <div className="status-item">
                                    <div className="status-item-title">{t('tou_item2_title')}</div>
                                    <div className="status-item-desc">{t('tou_item2_desc')}</div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="video-img">
                        <EfVideo
                            className="tou-video"
                            pc={currentLangObj.tou_video_pc}
                            poster="https://websiteoss.ecoflow.com/upload/image/1745484655255/image%205155779.png"
                            posterH5="https://websiteoss.ecoflow.com/upload/image/1745484748354/image%205155780.png"
                            loop={true}
                            autoPlay={true}
                            pad={currentLangObj.tou_video_pc}
                            h5={currentLangObj.tou_video_h5}
                        />
                        {euPages.includes(pageType) && (
                            <div className="video-desc">
                                {icons.map((Icon, index) => (
                                    <div className="video-desc-icon" key={index}>
                                        <Icon />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {pageType === 'na' && <SmartMeter />}
            {pageType !== 'na' && (
                <div className="power-ai right">
                    <div className="power-box video">
                        <div className="power-box-title">
                            <EcoSection subTitle={t('ai_r_subtitle')} title={ai_r_title} className="product-section" subTitleColor="#83868D" />
                            {euPages.includes(pageType) && (
                                <div className="status-box power">
                                    <div className="status-item">
                                        <div className="status-item-title">{t('ai_r_item1_title')}</div>
                                        <div className="status-item-desc">{t('ai_r_item1_desc')}</div>
                                    </div>
                                    <div className="status-line power"></div>
                                    <div className="status-item">
                                        <div className="status-item-title">{t('ai_r_item2_title')}</div>
                                        <div className="status-item-desc">{t('ai_r_item2_desc')}</div>
                                    </div>
                                    <div className="status-line power"></div>
                                    <div className="status-item">
                                        <div className="status-item-title">{t('ai_r_item3_title')}</div>
                                        <div className="status-item-desc">{t('ai_r_item3_desc')}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <EcoImg
                            className="power-ai-img"
                            pc={currentLangConfig.power1.pc}
                            pad={currentLangConfig.power1.pad}
                            h5={currentLangConfig.power1.h5}
                            isOpenLazy
                        />
                    </div>
                </div>
            )}
            {/* {pageType === 'na' && (
                <div className="power-ai left">
                    <div className="power-box video">
                        <EcoImg
                            className="power-ai-img"
                            pc={currentLangConfig.power2.pc}
                            pad={currentLangConfig.power2.pad}
                            h5={currentLangConfig.power2.h5}
                            isOpenLazy
                        />
                        <div className="power-box-title">
                            {euPages.includes(pageType) && <MinTitle title={t('save_more')} align="left" />}

                            <EcoSection subTitle={t('ai_l_subtitle')} title={t('ai_l_title')} className="product-section" subTitleColor="#83868D" />
                        </div>
                    </div>
                </div>
            )} */}

            {pageType !== 'na' && (
                <div className="energy-ai">
                    <div className="energy-ai-content">
                        <div className="energy-title-box">
                            {euPages.includes(pageType) && <MinTitle title={t('save_smart')} align="center" />}

                            <EcoSection
                                className="energy-box-title product-section"
                                subTitle={euPages.includes(pageType) ? '' : t('energy_ai_subtitle')}
                                title={energy_ai_title}
                                subTitleColor="#83868D"
                            />
                        </div>
                        {euPages.includes(pageType) ? (
                            <Smart pageType={pageType} />
                        ) : isH5 ? (
                            <>
                                <Swiper
                                    className="energy-ai-swiper"
                                    modules={[Navigation]}
                                    spaceBetween={16}
                                    navigation
                                    slidesPerView={'auto'}
                                    initialSlide={0}
                                    scrollbar={{
                                        hide: false,
                                        draggable: true,
                                        dragSize: 24,
                                        snapOnRelease: true,
                                    }}
                                >
                                    {arr.map((item: any, index: number) => (
                                        <SwiperSlide className="energy-ai-item" key={index}>
                                            {item.title && (
                                                <div className="smart-insights-card-info">
                                                    <div className="smart-insights-card-title">{item.title}</div>
                                                </div>
                                            )}

                                            {item.type === 'video' ? (
                                                <EfVideo
                                                    className="SmartInsights-video"
                                                    poster={item.posterPC}
                                                    pc={item.pc}
                                                    Icon={IconRePlay}
                                                    preload="none"
                                                    startPlay={startPlay}
                                                />
                                            ) : (
                                                <EcoImg className="energy-icon" pc={item.h5} isOpenLazy />
                                            )}

                                            {pageType !== 'normal' && <p className="energy-img-title">{item.desc}</p>}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </>
                        ) : (
                            <>
                                <div className="energy-imgs">
                                    {arr.map((item: any, index: number) => (
                                        <div className={`imgs-item ${item.type}`} key={index}>
                                            {item.title && (
                                                <div className={`smart-insights-card-info ${pageType}`}>
                                                    <div className="smart-insights-card-title">{item.title}</div>
                                                </div>
                                            )}
                                            {item.type === 'video' ? (
                                                <EfVideo
                                                    className="SmartInsights-video"
                                                    poster={item.posterPC}
                                                    pc={item.pc}
                                                    Icon={IconRePlay}
                                                    preload="none"
                                                    startPlay={startPlay}
                                                />
                                            ) : (
                                                <EcoImg className="energy-icon" pc={item.pc} h5={item.h5} isOpenLazy />
                                            )}
                                            {pageType !== 'normal' && <p className="energy-img-title">{item.desc}</p>}
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </section>
    );
};

export default EcoAi;
